// extracted by mini-css-extract-plugin
module.exports = {"card":"about-card-module--card--FL1In"};